// eslint-disable-next-line import/prefer-default-export
export const API_BASE_URL = process.env.NODE_ENV === "production" ? "https://sind-gleich-da.nog.codes" : "http://localhost:3015";
